import { h, Host } from "@stencil/core";
/**
 * The `ch-grid-action-settings` component represents a settings button for a grid action bar.
 */
export class ChGridActionSettings {
    constructor() {
        this.disabled = undefined;
    }
    /**
     * Event emitted when the settings button is clicked.
     */
    settingsShowClicked;
    pressedHandler(eventInfo) {
        if (!eventInfo.key || eventInfo.key === "Enter" || eventInfo.key === " ") {
            this.settingsShowClicked.emit();
            eventInfo.stopPropagation();
        }
    }
    render() {
        return h(Host, { role: "button", tabindex: "0", disabled: this.disabled });
    }
    static get is() { return "ch-grid-action-settings"; }
    static get originalStyleUrls() {
        return {
            "$": ["ch-grid-action-settings.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["ch-grid-action-settings.css"]
        };
    }
    static get properties() {
        return {
            "disabled": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Indicates whether the settings button is disabled or not."
                },
                "attribute": "disabled",
                "reflect": false
            }
        };
    }
    static get events() {
        return [{
                "method": "settingsShowClicked",
                "name": "settingsShowClicked",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "Event emitted when the settings button is clicked."
                },
                "complexType": {
                    "original": "any",
                    "resolved": "any",
                    "references": {}
                }
            }];
    }
    static get listeners() {
        return [{
                "name": "keydown",
                "method": "pressedHandler",
                "target": undefined,
                "capture": false,
                "passive": true
            }, {
                "name": "click",
                "method": "pressedHandler",
                "target": undefined,
                "capture": false,
                "passive": true
            }];
    }
}
//# sourceMappingURL=ch-grid-action-settings.js.map
